import { CTabView } from "src/components/CTabView";
import { LeaveTypePage } from "./LeaveTypePage";
import { HolidayPage } from "./HolidayPage";

export function LeaveHolidayPage() {
  return (
    <CTabView
      data={[
        {
          label: "Leave Types",
          component: <LeaveTypePage />,
        },
        {
          label: "Holidays",
          component: <HolidayPage />,
        },
      ]}
    />
  );
}
